import { post, get, baseURL } from "@/utils/request";

export const getRedeemcodeClaim = (data: any) => post(`/redeemCode/claimed`, data);